var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-layout',{staticClass:"system-notice"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("首页系统公告")])]),_c('div',{attrs:{"slot":"container"},slot:"container"},[_vm._v(" 首页系统公告内容 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }